import icon1 from "../../Quiz-app/images/gold.png";
import icon2 from "../../Quiz-app/images/silver.png";
import icon3 from "../../Quiz-app/images/bronge.png";
import { useState } from "react";
import userStore from "../../../zustand/userStore";

const Leaderboard = ({ leaderboard, questions = [], totalMarks }) => {
  const winners = leaderboard || [];
  // 🔑 Get logged-in user id from localStorage
  //   const userData = JSON.parse(localStorage.getItem("userData_quiz"));
  //   const userData = useState;
  const userData = userStore((state) => state.user);

  const currentUserId = userData?.id;
  // ✅ No sorting or rank assignment — show as-is
  const displayedUsers = winners;

  const medalImages = [icon1, icon2, icon3];
  console.log("JSON.string", JSON.stringify(winners));
  return (
    <div className="w-100">
      <div
        className="card"
        style={{
          backgroundColor: "white",
          minHeight: "80vh",
          overflowY: "auto",
          border: "3px solid #4b62cd",
        }}
      >
        <h2 className="text-xl font-bold mb-4 text-center text-indigo-600">
          🏆 Leaderboard
        </h2>

        {displayedUsers.length === 0 ? (
          <p className="text-center text-gray-500">No users yet</p>
        ) : (
          <>
            {displayedUsers.map((user, index) => (
              <LeaderboardRow
                key={user.user_id}
                user={user}
                index={index} // just the array index (not rank)
                medalImages={medalImages}
                totalQuestions={questions.length}
                totalMarks={totalMarks}
                highlight={user.user_id === currentUserId} // green background if logged-in user
              />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

const LeaderboardRow = ({
  user,
  index,
  medalImages,
  totalQuestions,
  highlight,
  totalMarks,
}) => (
  <div
    className="mb-2"
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "10px",
    }}
  >
    <div
      className={!highlight && "user_score"}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "90%",
        border: "1px solid #ccc",
        padding: "10px",
        borderRadius: "16px",
        marginLeft: "5%",
        height: "5vh",
        backgroundColor: highlight && "#4CAF50", // ✅ green highlight if current user
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "5px",
          alignItems: "center",
        }}
      >
        <div style={{ padding: "3px" }}>
          {index < 3 ? (
            <img
              src={medalImages[index]}
              style={{ width: "20px" }}
              alt="medal"
            />
          ) : (
            <span
              className="winner-index bg-light-red rounded-full"
              style={{
                color: "black",
                padding: "1px 4px",
                fontSize: "0.75rem",
                minWidth: "10px",
                minHeight: "20px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {index + 1}
            </span>
          )}
        </div>
        <span className="winner-name text-14" style={{ color: "white" }}>
          <b>{user.admin_name}</b>
        </span>
      </div>

      <span className="winner-score text-15">
        {user.total_score}/{totalMarks}
        {/* {totalQuestions} */}
      </span>
    </div>
  </div>
);

export default Leaderboard;
